import * as React from 'react';
import { Route, Routes, Outlet } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import TornadoesPageLayout from './TornadoesPageLayout';
import Dashboard from './Dashboard';
import News from './News';
import Contacts from './Contacts';
import Store from './Store';
import Team10uPassante from './Team10uPassante';
import Team12uBeard from './Team12uBeard';
import Team12uBeck from './Team12uBeard';
import Team14uGentile from './Team14uGentile';
import Team14uGreen from './Team14uGreen';
import Team16uCulligan from './Team16uCulligan';
import './App.css';

function App() {
  return (
    <div>
        <HelmetProvider>
          <Helmet>
            <title>F5 Tornadoes Travel Softball</title>
          </Helmet>
          </HelmetProvider>
          <TornadoesPageLayout>
            <Outlet />
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/10u-passante" element={<Team10uPassante />} exact />
              <Route path="/12u-beard" element={<Team12uBeard />} exact />
              <Route path="/12u-beck" element={<Team12uBeck />} exact />
              <Route path="/14u-gentile" element={<Team14uGentile />} exact />
              <Route path="/14u-green" element={<Team14uGreen />} exact />
              <Route path="/16u-culligan" element={<Team16uCulligan />} exact />
              <Route path="/news" element={<News />} exact />
              <Route path="/contacts" element={<Contacts />} exact />
              <Route path="/store" element={<Store />} exact />
              <Route
                path="*"
                element={
                  <main style={{ padding: '1rem' }}>
                    <p>There's nothing here!</p>
                  </main>
                }
              />
            </Routes>
          </TornadoesPageLayout>
      </div>
  );
}

export default App;
